/* eslint-disable react/display-name */
import React from 'react';

import Button, { ButtonWithSpinnerContainer } from 'shared/styles/components/Button';
import { ButtonSpinner } from 'shared/styles/components/Spinner';

export default ({
  isLoading,
  confirmText,
  loadingStyleProp,
  notLoadingStyleProp,
  clickHandler,
  disabled,
  title,
  autoFocus,
  acountForm,
}) =>
  isLoading ? (
    <ButtonWithSpinnerContainer>
      <Button type="submit" acountForm={acountForm} {...(loadingStyleProp ? { [loadingStyleProp]: true } : {})}>
        {confirmText}
      </Button>
      <ButtonSpinner />
    </ButtonWithSpinnerContainer>
  ) : (
    <>
      <Button
        type="submit"
        autoFocus={autoFocus}
        disabled={disabled}
        disabledStyleProp={disabled}
        {...(notLoadingStyleProp ? { [notLoadingStyleProp]: true } : {})}
        onClick={clickHandler}
        title={title}
      >
        {confirmText}
      </Button>
    </>
  );
